import axios from 'axios'

const publicApiClient = axios.create({
  baseURL: import.meta.env.VITE_PUBLIC_API_URL,
  headers: { 'Content-Type': 'application/json' },
})

publicApiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('token')

  if (token) {
    config.headers['X-Auth-Token'] = token
  }

  return config
})

export default publicApiClient
